import { render, staticRenderFns } from "./cockroftGault.vue?vue&type=template&id=5664477d"
import script from "./cockroftGault.vue?vue&type=script&lang=js"
export * from "./cockroftGault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports